import { Dialog, DialogContent, DialogActions, Typography, Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";
import { PoButton } from "../common/PoButton";

interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
  resourceLabel?: string;
  max?: number;
}

export function UpgradeModal({ open, onClose, resourceLabel, max }: UpgradeModalProps) {
  const tenantPlan = useAtomValue(AppAtoms.tenantPlanAtom);

  const countText = resourceLabel && max ? `(${max}${resourceLabel === "パートナー" ? "社" : "件"})` : "";
  const title = resourceLabel
    ? `${resourceLabel}数が上限${countText}に達しています。`
    : "プランの上限に達しています。";

  return (
    <Dialog
      open={open}
      // cmd-po_1247: 背景クリック/ESCで閉じない（onClose撤去+disableEscapeKeyDown）。閉じるは footer「閉じる」のみ
      disableEscapeKeyDown
      maxWidth={false}
      data-testid="upgrade-modal"
      PaperProps={{
        sx: {
          // カタログ #07 po-modal: A2裁定=560px/92vh/右寄せフッタ
          // UpgradeModal: m_upgrade_pc.html sx7=460px（narrow）
          // F-A是正: MUI Dialog既定margin=32px/side→16px/sideへ（SP実幅=calc(100vw-32px)=358px）
          width: 460,
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "92vh",
          m: "16px",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-elevated)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogContent
        sx={{
          // cc-body sx8: center + gap sp-4 + padding-top sp-6
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "var(--sp-3)",
          p: "var(--sp-4) var(--sp-5)",
          pt: "var(--sp-6)",
          overflowY: "auto",
        }}
      >
        {/* sx9: アイコン円 48px / color-ai-pale / color-ai */}
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: "var(--color-ai-pale)",
            color: "var(--color-ai)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <LockIcon sx={{ fontSize: 22 }} />
        </Box>
        {/* sx10: タイトル fs-15 / fw-bold / color-sumi / font-heading */}
        <Typography
          sx={{
            fontSize: "var(--fs-15)",
            fontWeight: "var(--fw-bold)",
            color: "var(--color-sumi)",
            fontFamily: "var(--font-heading)",
            lineHeight: 1.4,
          }}
        >
          {title}
        </Typography>
        {/* sx11: 説明文 fs-12 / color-sumi-light / lineHeight 1.7 */}
        {tenantPlan?.plan_name && (
          <Typography
            sx={{
              fontSize: "var(--fs-12)",
              color: "var(--color-sumi-light)",
              lineHeight: 1.7,
            }}
          >
            現在のプラン: {tenantPlan.plan_name}
          </Typography>
        )}
        <Typography sx={{ fontSize: "var(--fs-12)", color: "var(--color-sumi-light)", lineHeight: 1.7 }}>
          既存データは削除されません（新規追加のみ制限）。
        </Typography>
      </DialogContent>
      {/* sip-foot: 閉じるButton単体・中央寄せ（secondary Button+注記 退役 cmd-po_1189） */}
      <DialogActions
        sx={{
          justifyContent: "center",
          px: "var(--sp-5)",
          pb: "var(--sp-3, 12px)",
          pt: "var(--sp-3)",
          borderTop: "1px solid var(--color-border-light)",
          flexShrink: 0,
        }}
      >
        <PoButton variant="secondary" onClick={onClose}>
          閉じる
        </PoButton>
      </DialogActions>
    </Dialog>
  );
}
